import { call, put, select } from 'redux-saga/effects';
import dayjs from 'dayjs';
import { t } from 'i18next';
import { Api } from 'entries/ApiTransport';
import { salonManagementActions } from 'Containers/SalonManagement/store';
import { toastActions } from 'Containers/Toasts/store';
import { getActiveSalonId } from 'utils/salonToken';
import { getDemoBundle } from './buildDemoData';
import { isDemoMode, readDemoModeFromStorage } from './isDemoMode';

const api = Api.getInstance();

export function* selectIsDemoMode() {
  const { salon, id } = yield select((state) => {
    const id = state.authReducer?.activeSalonId;
    const salon = (state.authReducer?.salons || []).find((item) => +item.idsalone === +id);
    return { salon, id };
  });
  // Solo il salone corrente. Un altro salone in demo in lista non deve intercettare le API.
  if (salon) return isDemoMode(salon);
  return readDemoModeFromStorage(id);
}

function* ensureWorkers() {
  let workers = yield select((state) => state.salonManagementReducer?.workers);
  if (!Array.isArray(workers) || !workers.length) {
    workers = yield select((state) => state.schedulerReducer?.calendar?.workers);
  }
  if (Array.isArray(workers) && workers.length) return workers;
  try {
    const { data } = yield call(() => api.get('/business/poltrone/getPoltrone'));
    workers = data?.poltrone || [];
    if (workers.length) {
      yield put(salonManagementActions.GET_WORKERS.SUCCESS(workers));
    }
  } catch (_) {
    workers = [];
  }
  return workers;
}

function* ensureServices() {
  let services = yield select((state) => state.salonManagementReducer?.services);
  if (!Array.isArray(services) || !services.length) {
    services = yield select((state) => state.schedulerReducer?.calendar?.services);
  }
  return Array.isArray(services) ? services : [];
}

export function* getLiveDemoBundle({ workers, services } = {}) {
  const resolvedWorkers = workers || (yield* ensureWorkers());
  const resolvedServices = services || (yield* ensureServices());
  return getDemoBundle({
    salonId: getActiveSalonId(),
    workers: resolvedWorkers,
    services: resolvedServices,
    today: dayjs().format('YYYY-MM-DD'),
  });
}

export function* demoBlockedToast() {
  yield put(
    toastActions.OPEN_TOAST.SUCCESS({
      type: 'api',
      props: {
        title: t('common.toastMessages.demoModeBlocked'),
        warning: true,
      },
    }),
  );
}
